/**
 * Transforms translation data from API response to key-value pairs
 * @param {Object|Array} response - API response containing translations
 * @returns {Object} Transformed translations object with labelID as keys
 */
export const transformTranslationData = (response) => {
	// Extract translations from nested structure
	let translationsData = response?.data;

	// Transform to key-value pairs
	const translations = {};
	const dataArray = Array.isArray(translationsData) ? translationsData : Object.values(translationsData);

	dataArray.forEach((item) => {
		if (item?.labelID && item?.ar) {
			translations[item.labelID] = item.ar;
		} else if (item?.labelID && item?.en) {
			translations[item.labelID] = item.en;
		}
	});

	return translations;
};
